import {Component} from '@angular/core';
import {TypeProfil} from "@domain/user/user";
import {TranslateService} from "@ngx-translate/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {PopulationUsage} from "@domain/admin/entreprise/population/population-usage";
import {Router} from "@angular/router";

/**
 * Composant d'affichage de la page Population Usage Item
 *
 * @author Lionel Gimenez
 * @date 20/05/2025
 */
@Component({
    host: {'data-test-id': 'population-usage-item'},
    templateUrl: './population-usage-item.component.html'
})
export class PopulationUsageItemComponent extends ListViewItem<PopulationUsage> {
    /**
     * Constructeur
     */
    constructor(
        public translateService: TranslateService,
        private router: Router,
    ) {
        super();
    }

    /**
     * Retourne le libellé
     */
    getFonctionLibelle(typeProfil: TypeProfil): String {
        return TypeProfil.getLibelle(this.translateService,typeProfil);
    }

    /**
     * Retourne l'avatar
     */
    getAvatar(typeProfil: TypeProfil): String {
        return TypeProfil.getLibelle(this.translateService,typeProfil).slice(0,3);
    }

    /**
     * Handler du click sur l'item
     */
    onSelect() {
        //Navigation vers la page du détail des usages
        this.router.navigate(['Admin/Entreprise/Populations/Population/' + this.data.idPopulation + '/Usage/' + this.data.fonction]);
    }
}